<template>
  <b-container fluid class="padding-none">
    <ui-header />
    <button-logout class="logout" />
    <b-row v-if="imageLink !== ''" class="px-md-2 pt-md-4 row-padding">
      <b-col md="6">
        <div class="d-none d-md-block">
          <side-image />
        </div>
      </b-col>
      <b-col md="6" class="px-4 pr-md-6">
        <router-view />
      </b-col>
    </b-row>
    <b-row class="h-100" v-else>
      <b-col md="12" class="h-100 padding-none bottom-policy">
        <button-logout />
        <router-view />
        <bottom-policies />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ProductImage from "../../components/product/image";
import ButtonLogout from "../../components/ui/button-logout";
import BottomPolicies from "../../components/ui/bottom-policies";
import UiHeader from "../../components/ui/app-header";
import SideImage from "../../components/ui/side-image";
import { mapGetters } from "vuex";

export default {
  name: "layouts-match",
  components: {
    ProductImage,
    ButtonLogout,
    BottomPolicies,
    UiHeader,
    SideImage
  },
  data() {
    return {
      loaded: false,
      updated: false
    };
  },
  computed: {
    ...mapGetters({
      imageLink: "pageParams/getImageLink",
      _loading: "ui/loading"
    })
  }
};
</script>

<style scoped>
@media only screen and (min-width: 600px) {
  .row-padding {
    margin: 0 3rem 3rem 3rem;
  }
}
.bottom-policy {
  padding-bottom: 59px;
}
</style>
